export const problemCardCopy: Record<string, { title: string; body: string }> = {
  "preparing-new-supervisors": {
    title: "Your new supervisors are drowning",
    body: "Great at the job, new to running people. Nobody taught them the second part.",
  },
  "creating-consistent-leadership": {
    title: "Every manager runs their team differently",
    body: "Same company, ten different standards. Employees notice. So does your turnover number.",
  },
  "building-accountability": {
    title: "Nothing sticks after it's assigned",
    body: "Expectations live in someone's head, follow-through varies by manager, and HR ends up as the enforcement layer.",
  },
  "improving-difficult-conversations": {
    title: "Hard conversations keep getting postponed",
    body: "Small problems become HR problems because nobody said anything in month one.",
  },
  "leading-through-change": {
    title: "Change gets announced, then stalls",
    body: "Leadership decides, middle managers shrug, the front line never hears why.",
  },
  "scaling-leadership-development-lean-hr": {
    title: "You're the whole training department",
    body: "You know your leaders need development. You shouldn't have to build and carry all of it yourself.",
  },
};
